import React from 'react';
import { CSSObject } from 'styled-components';
import { SvgIconStyled } from './svgIcon.styled';
import { Size } from './types';

interface SvgIconProps {
  icon: React.ReactNode;
  color?: 'primary' | 'secondary' | 'wfWhite' | 'wfBlack' | 'minimal';
  size?: keyof typeof Size;
  sx?: CSSObject;
}

const SvgIcon = ({ icon, ...rest }: SvgIconProps) => {
  return <SvgIconStyled {...rest}>{icon}</SvgIconStyled>;
};

SvgIcon.defaultProps = {
  size: Size.small,
};

export default SvgIcon;
